import { updateAllHeaderCustomProperties } from '@theme/utilities';

// Bogue Horizon (intermittent, surtout Safari) : --top-row-height est mesurée
// une seule fois au chargement (rAF de l'inline script de theme.liquid /
// utilities.js). Si la mesure tombe avant que le header finisse sa mise en
// page (liens du menu encore empilés), elle fige une valeur absurde (ex.
// 280px) que rien ne recalcule ensuite — les ResizeObservers d'Horizon ne
// rafraîchissent que --header-height et --header-group-height. Or le panneau
// du mega menu est rogné par clip-path: rect(var(--top-row-height) ...)
// (blocks/_header-menu.liquid) : il apparaît alors tronqué jusqu'au reload.
// Correctif auto-réparant, sans modifier les fichiers Horizon : on remesure
// les variables du header dès que le rang supérieur change de taille, au
// chargement complet et après le chargement des polices.

const refresh = () => requestAnimationFrame(() => updateAllHeaderCustomProperties());

const topRow = document.querySelector('header-component .header__row--top');
if (topRow) {
  // Se déclenche aussi une première fois à l'observation : répare d'emblée
  // une valeur déjà corrompue.
  new ResizeObserver(refresh).observe(topRow);
}

window.addEventListener('load', refresh);
document.fonts?.ready.then(refresh);
